import React, { createElement, memo, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { App } from '@gin-betting/core';

import { useAppliedFilters } from 'hooks';
import ui from 'modules/ui';
import { ALL, OverlayType } from '../../../constants';
import MobileFiltersCtx from './MobileFiltersCtx';

const {
    actions: { setActiveMobileCountryKey },
} = ui;

const MobileFiltersCtxProvider: React.FC = ({ children }) => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const { sportId } = useAppliedFilters();
    const [currentOverlay, setOverlay] = useState<OverlayType>(
        OverlayType.NONE
    );

    useEffect(() => {
        if (pathname === App.Routes.UPCOMING_LIST) return;

        setOverlay(OverlayType.NONE);
        dispatch(setActiveMobileCountryKey(ALL));
    }, [dispatch, pathname]);

    useEffect(() => {
        dispatch(setActiveMobileCountryKey(ALL));
    }, [dispatch, sportId]);

    return createElement(
        MobileFiltersCtx.Provider,
        {
            value: {
                currentOverlay,
                setOverlay,
            },
        },
        children
    );
};

export default memo(MobileFiltersCtxProvider);
